import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { PlaylistSummary } from 'src/features/AddToPlaylist/api';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState, useCallback } from 'react';
import { usePlaylistMutations } from 'src/features/AddToPlaylist';

const Tile = styled(NavLink)`
  display: block;
  padding: 16px;
  border: ${(p) => p.theme.border};
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

export function PlaylistCard({ row }: { row: PlaylistSummary }) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const { removePlaylist } = usePlaylistMutations();
  const canEdit = row.playlistType === 'custom';

  const onDel = useCallback(() => {
    setAnchor(null);
    if (!canEdit) return;
    void removePlaylist.mutateAsync(row.id).catch(() => {});
  }, [canEdit, removePlaylist, row.id]);

  return (
    <Tile to={`/me/playlists/${row.id}`}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
        <div>
          <Typography variant="subtitle1">{row.name}</Typography>
          <Typography variant="caption" color="textSecondary">
            {row.itemCount} pozycji
          </Typography>
        </div>
        {canEdit && (
          <>
            <IconButton size="small" onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setAnchor(e.currentTarget);
            }}>
              <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
              <MenuItem onClick={onDel}>Usuń</MenuItem>
            </Menu>
          </>
        )}
      </div>
    </Tile>
  );
}
